@import "../../themes/stories.globals";

.bar {
  color: var(--stories-bar-text-color, black);
  width: 100%;
  height: 40px;
  flex-shrink: 0;
  overflow: auto;
  overflow-y: hidden;
}

.inner {
  display: flex;
  justify-content: space-between;
  position: relative;
  flex-wrap: nowrap;
  flex-shrink: 0;
  height: 40px;
  background-color: transparent;
}

.side {
  display: flex;
  white-space: nowrap;
  flex-basis: auto;
  flex-shrink: 0;
  margin-left: 3px;
  margin-right: 3px;
}

.side.left > * {
  margin-left: 4px;
}

.side.right {
  margin-left: 30px;
}

.side.right > * {
  margin-right: 4px;
}
